import React, { Component } from "react";
import birthday from "../../../Assets/img/birthday.png";
import celeb from "../../../Assets/img/celeb.svg";

class BirthdayCard extends Component {
  render() {
    return (
      <>
        <div className="overflow-hidden" style={{ borderRadius: 20 }}>
          <div
            className="w-100 p-5"
            style={{
              height: 350,
              backgroundImage: `url(${birthday})`,
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          >
            <div
              className="w-100 "
              style={{
                height: 150,
                backgroundImage: `url(${celeb})`,
                backgroundPosition: "center",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
              }}
            ></div>
            <div className="th-brusher th-30 th-white d-flex justify-content-center mt-3">
              Happy Birthday
            </div>
            <div className="th-brusher th-24 th-white d-flex justify-content-center mt-3 text-center">
              {this.props.name}
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default BirthdayCard;
